// const formatter = Intl.NumberFormat(undefined, {
//   currency: "PKR",
//   style: "currency",
// });

const formatter = Intl.NumberFormat("en-PK");

export const getPrice = (price) => {
  return `Rs.${formatter.format(price)}`;
};

export const stringToDate = (dt) => {
  const date = new Date(dt);
  return `${date.getDate()}/${date.getMonth()}/${date.getFullYear()}`;
};

export const getDateFormate = (dob) => {
  return `${new Date(dob).getDate()}-${new Date(dob).getMonth()}-${new Date(
    dob
  ).getFullYear()}`;
};

export const executeWithTime = (obj, message) => {
  const d = new Date();
  return console.log(obj, d.toLocaleTimeString() + " - " + message);
};

export const getAddressFormat = (obj) => {
  return {
    main_address: `${obj.address1}, 
    ${obj.address2 == null || obj.address2 === "" ? "" : obj.address2 + ", "} ${
      obj.stateName == null || obj.stateName === "" ? "" : obj.stateName + ", "
    } ${obj.cityName}${
      obj.postCode == null || obj.postCode === "" ? "" : ", " + obj.postCode
    }`,
    phone: `${obj.phone}`,
    addressId: obj.addressId,
    addressName: obj.addressName,
    address: obj,
  };
};

export const getOrderAddressFormat = (order = {}) => {
  const addressParts = [
    order.userAdd,
    order.userCity,
    order.userCo,
  ].filter(
    (item) =>
      item !== null &&
      item !== undefined &&
      item.toString().trim() !== ""
  );

  return {
    name:
      order.fullName ||
      [order.userFName, order.userMName, order.userLName]
        .filter(Boolean)
        .join(" "),

    phone: order.userMobile || order.userPhone || "",

    main_address: addressParts.join(", "),

    orderId: order.orderId,
    raw: order,
  };
};

export function totalCartItems(cartItems) {
  const totalItemsLen = cartItems.reduce((curNum, item) => {
    return curNum + item.productQty;
  }, 0);

  return totalItemsLen;
}

export function totalCheckoutItems(checkoutItems) {
  const allTotalItemsLen = checkoutItems.reduce((curNum, item) => {
    return curNum + item.productQty;
  }, 0);

  return allTotalItemsLen;
}

export function checkoutItemsLen(checkoutItems) {
  const totalItemsLen = checkoutItems.length;

  return totalItemsLen;
}

// input validation regex

export const emialRegex =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

// export const Currency = "Rs.";
export const localStoragePrefix = "muradi_web-";


const BUCKET_URL = process.env.REACT_APP_BUCKET_URL?.replace(/\/$/, "") || "";

export const getBucketUrl = (path = "") => {
  if (typeof path !== "string") return "";

  const trimmedPath = path.trim();

  if (!trimmedPath) return "";

  // already absolute url
  if (/^https?:\/\//i.test(trimmedPath)) {
    return trimmedPath;
  }

  return `${BUCKET_URL}/${trimmedPath.replace(/^\//, "")}`;
};